const masks = {
  phone: {
    mask: "+34(6|7)9{8}",
    greedy: false,
    placeholder: "",
    onBeforePaste: function (pastedValue) {
      var maxLength = 9
      if (pastedValue.startsWith("+34")) {
        var trimmedValue = pastedValue.slice(0, maxLength + 3)
        return trimmedValue
      }
      return ""
    },
  },
  personal_code: {
    mask: "99999999X",
    placeholder: "",
    definitions: {
      9: {
        validator: "[0-9]",
        cardinality: 1,
      },
      X: {
        validator: "[0-9A-Za-z]",
        casing: "upper",
      },
    },
  },
  bank_account_number: {
    // Mask with spaces for readability
    mask: "ES99 9999 9999 9999 9999 9999",
    greedy: false,
    // Placeholder showing format example
    placeholder: "ESXX XXXX XXXX XXXX XXXX XXXX",
    // Removed onBeforePaste to let Inputmask handle pasting/typing directly
    // Inputmask will try to fit pasted content into the mask.
  },
}

// jQuery("#LeadForm-phone").inputmask(masks.phone) // Keep original inputmask commented

jQuery("#LeadForm-phone").on("focus input", function() {
  setInitialValue()

  if (!jQuery(this).val().startsWith('+34 ')) {
    jQuery(this).val('+34 ');
  }
})

// Add input event listener to strip non-numeric characters (allow +, space for mask)
jQuery("#LeadForm-phone").on("input", function() {
  var currentValue = $(this).val();
  // Allow digits, '+', and space (used by the mask)
  var cleanedValue = currentValue.replace(/[^0-9\+ ]/g, '');

  // Only update if the cleaned value is different and not just the initial prefix
  // This helps prevent cursor jumping issues with the mask plugin
  if (currentValue !== cleanedValue) {
      // Store cursor position
      var cursorPosition = this.selectionStart;
      var originalLength = currentValue.length;

      $(this).val(cleanedValue);

      // Restore cursor position adjusted for removed characters
      var newLength = cleanedValue.length;
      var diff = originalLength - newLength;
      var newCursorPosition = Math.max(0, cursorPosition - diff); // Ensure position is not negative

      // Special handling if cursor was at the end
      if (cursorPosition === originalLength) {
          newCursorPosition = newLength;
      }

      // Set the cursor position back
      // Use try-catch as setSelectionRange might fail in some edge cases or browsers
      try {
        this.setSelectionRange(newCursorPosition, newCursorPosition);
      } catch (e) {
        console.warn("Could not set selection range on phone input:", e);
      }
  }
});


function setInitialValue() {
  var leadPhone = jQuery('#LeadForm-phone');
  if (!leadPhone.val().trim()) {
    leadPhone.val('+34 ');
  }
}

// Apply the jQuery Mask plugin for Phone
jQuery("#LeadForm-phone").mask("+34 X00 000 000", {'translation': {
    X: {pattern: /[6|7]/}
  }
})

// Apply Inputmask for Personal Code
jQuery("#LeadForm-personal_code").inputmask(masks.personal_code)

// Apply Inputmask for Bank Account Number with the updated mask definition
jQuery("#LeadForm-bank_account_number").inputmask(masks.bank_account_number)
